import { COLORS } from '@/theme';
import { styled } from 'styled-components';

export const StyledButtons = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;

  button.ant-btn {
    padding: 0.5rem;
  }
`;

export const StyledStatus = styled.div<{
  $active?: boolean;
}>`
  display: inline-flex;
  border-radius: 99em;
  align-items: center;
  gap: 0.5rem;
  padding: 0.25rem 0.5rem;
  color: ${COLORS.WHITE};
  background-color: ${({ $active }) => ($active ? COLORS.GREEN : COLORS.RED)};
`;

export const StyledTruncate = styled.div`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const StyledQuestion = styled(StyledTruncate)`
  font-weight: 500;
`;

export const StyledAnswer = styled(StyledTruncate)`
  color: ${COLORS.GRAY_6};
`;

export const StyledDate = styled.span`
  color: ${COLORS.GRAY_6};
`;

export const StyledSearchWrapper = styled.div`
  display: flex;
  gap: 0.25rem;
  align-items: flex-start;
  flex-direction: column;
`;
